import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';
import jQuery from 'jquery';
import moment from 'moment';
import * as Sentry from '@sentry/browser';
import { Vue as SentryVueIntegration } from '@sentry/integrations';
import { extendMoment } from 'moment-range';

window.$ = window.jQuery = jQuery;
window.Vue = Vue;
window._ = _;
window.axios = axios;
window.moment = extendMoment(moment);


window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': token.content}});
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

if(process.env.NODE_ENV === 'production') 
{
    Sentry.init({
        dsn: CONFIG.SENTRY_DSN,
        integrations: [ new SentryVueIntegration({ Vue, attachProps: true }) ],
        environment: process.env.NODE_ENV,
        release: process.env.VERSION
    });
    
    console.sentryMessage = function(str) {
        Sentry.captureMessage(str);
    };
}
else {
    console.sentryMessage = function(str) {
        console.log("SentryMessage (not sent): "+str);
    };
}

/* override of default functionality from: craftable/coreui/index.js */
/* prevent "forgot" spinner on grid buttons when return back from target site without full reload of page (back button in browser) */
$(function(){
    $('.btn-spinner').on('click', function(e)
    {   
        var btnEl = $(this);
        var originalClassName = btnEl.find("i").attr("class");
        
        setTimeout(function() {
            btnEl.css({'pointer-events':'unset'});
            btnEl.find('i').attr("class", originalClassName); 
        },500);
    });
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/bootstrap.js